import rpo34 from "./rpo34";
import rpo35 from "./rpo35";
import rpo36 from "./rpo36";

export default {
    rpo34,
    rpo35,
  rpo36,
};